// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__13fCI","emails":"CreateEditClinics_emails__1u9bx","emailTagLabel":"CreateEditClinics_emailTagLabel__yF4S9"};